import React from "react";

/**
 * Responsive 16:9 YouTube embed. Accepts either a full URL or a bare video ID.
 * Wraps the iframe in a fluid aspect-ratio container so it scales beautifully
 * from mobile to desktop without layout shift.
 */
function extractVideoId(input) {
  if (!input) return "";
  // already an ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(input)) return input;
  try {
    const url = new URL(input);
    // youtu.be/<id>
    if (url.hostname.includes("youtu.be")) {
      return url.pathname.replace(/^\//, "").split("/")[0];
    }
    // youtube.com/watch?v=<id>
    const v = url.searchParams.get("v");
    if (v) return v;
    // youtube.com/embed/<id> or /shorts/<id>
    const parts = url.pathname.split("/").filter(Boolean);
    return parts[parts.length - 1] || "";
  } catch {
    return input;
  }
}

export default function YouTubeEmbed({ url, title = "Course preview video", testId = "youtube-embed" }) {
  const id = extractVideoId(url);
  if (!id) return null;
  const src = `https://www.youtube.com/embed/${id}?rel=0&modestbranding=1`;
  return (
    <div
      data-testid={testId}
      className="relative w-full aspect-video bg-black border border-[#1a1a1a] overflow-hidden shadow-[0_0_60px_rgba(212,175,55,0.08)]"
    >
      <iframe
        src={src}
        title={title}
        loading="lazy"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
        className="absolute inset-0 w-full h-full"
      />
    </div>
  );
}
